import { getReturnUrl } from "@client/lib/misc";
import { getMultiselectValue } from "@client/lib/settings";
import { type CompositeSettings, type FunnelInfoAppState, JustifyContentType, ScreenType } from "@client/types";
import { isUndefined } from "lodash";

const ALIGN_TO_ALIGN_SELF = {
  left: "flex-start",
  center: "center",
  right: "flex-end"
};
export const alignToAlignSelf = (align: string): JustifyContentType => ALIGN_TO_ALIGN_SELF[align];

const ALIGN_TO_JUSTIFY_CONTENT_TYPE = {
  left: JustifyContentType.Start,
  center: JustifyContentType.Center,
  right: JustifyContentType.End
};
export const alignToJustifyContent = (align: string): JustifyContentType => ALIGN_TO_JUSTIFY_CONTENT_TYPE[align];

export type RedirectTo = {
  newTab: boolean;
  type: CompositeSettings.RedirectToType;
  funnelPathId?: string | null;
  pageId?: string | null;
  popupContentId?: string | null;
  qs?: string[] | null;
  url?: string | null;
};

const createFromSettingBase = (
  setting: CompositeSettings.Redirect | null | undefined,
  screenType: ScreenType
): RedirectTo | undefined => {
  if (!setting) return;

  const redirectTo = setting.to;
  const redirectToFunnelPath = setting.funnelPath;
  const redirectToNewTab = setting.newTab;
  const redirectToTab = setting.page;
  const redirectToPopup = setting.popup;
  const redirectToQueryString = setting.queryString ? getMultiselectValue(setting.queryString) : undefined;
  const redirectToUseReturnUrl = setting.useReturnUrl;
  const redirectToUrl = setting.url;

  return {
    newTab: screenType === ScreenType.Mobile ? false : redirectToNewTab ?? false,
    type: redirectTo,
    funnelPathId: isUndefined(redirectTo) || redirectTo === "step" ? redirectToFunnelPath : null,
    pageId: isUndefined(redirectTo) || redirectTo === "tab" ? redirectToTab : null,
    popupContentId: isUndefined(redirectTo) || redirectTo === "popup" ? redirectToPopup : null,
    qs: redirectToQueryString,
    url:
      (redirectToUseReturnUrl ? getReturnUrl() : null) ??
      (isUndefined(redirectTo) || redirectTo === "url" || redirectTo === "lightbox" ? redirectToUrl : null)
  };
};
export const redirectTo = {
  createFromSettingBase,
  createFromSetting: (
    setting: CompositeSettings.Redirect | null | undefined,
    funnelInfo: FunnelInfoAppState | null | undefined,
    screenType: ScreenType
  ): RedirectTo | undefined => {
    const result = createFromSettingBase(setting, screenType);

    if (!result) return;

    if (!result.url && !result.popupContentId && !result.pageId && !result.funnelPathId) return;

    if (result.type === "step" && result.funnelPathId) {
      if (!funnelInfo) return;

      const path = funnelInfo.funnelPaths.find((x) => x.funnelPathId === result.funnelPathId);
      if (!path) return;
    }

    return result;
  }
};
